import { getSortByString } from '@nbirl/nbi-common-ui-libs';

import { useQueryParams } from '../../../shared/hooks';
import { ResourceList } from '../common/components';
import { DocumentsListState } from '../documents/models';
import { EmptyPendingApproval, PendingApprovalCount } from './components';
import { usePendingApprovalQuery } from './queries';

export const PendingApproval = () => {
  const [query, setQuery] = useQueryParams<DocumentsListState>({
    pageSize: 50,
    pageIndex: 0,
    sortBy: getSortByString({ id: 'name', desc: false }),
    search: '',
  });

  const { data, error, isLoading, refetch } = usePendingApprovalQuery(query);

  return (
    <ResourceList
      heading={<PendingApprovalCount />}
      isLoading={isLoading}
      error={error}
      list={{
        documents: data?.content || [],
        folders: [],
      }}
      totalElements={0}
      pageCount={0}
      query={query}
      emptyState={<EmptyPendingApproval />}
      disableStatusSort
      onRefetch={refetch}
      onQueryChange={setQuery}
    />
  );
};
